import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import classes from './NavigationItem.css';

const navigationItem = React.memo((props) => (
  <li className={classes.NavigationItem} key={props.key}>
    <NavLink
      to={props.link}
      exact={props.exact}
      activeClassName={classes.active}
    >
      {props.children}
    </NavLink>
  </li>
));

export default withRouter(navigationItem);
